import { Button, ButtonMode } from "components/Button/Button";
import { Icon, IconType } from "components/Icon/Icon";
import TruLink from "components/TruLink/TruLink";

import type * as History from "history";
import type { WindowId } from "constants/tee";

export interface MenuItemDataType {
  icon?: IconType;
  btnClass?: string;
  linkClass?: string;
  onClick?: () => {};
  separator?: boolean;
  singleInstanceId?: WindowId;
  isExternal?: boolean;
  tooltip?: string;
  badge?: number | string;
  openInNewTab?: boolean;
}
export interface LinkRenderPropsType {
  dir: string;
  itemId: string;
  opened: boolean;
  item: {
    cssClass?: string;
    text?: string;
    url?: string;
    disabled?: boolean;
    data?: MenuItemDataType;
    items?: LinkRenderPropsType[];
  };
}
export interface createLinkRenderType {
  hasChangesCallback?: (to: History.History.LocationDescriptor, clickHandler?: () => void) => void;
  isErrorMode: boolean;
  encounterOpened: boolean;
  onNavigateAway?: () => void;
}

export function createLinkRender({
  hasChangesCallback,
  isErrorMode,
  encounterOpened,
  onNavigateAway,
}: createLinkRenderType): (props: LinkRenderPropsType) => JSX.Element {
  return ({ item }: LinkRenderPropsType) => {
    const customData = item.data ?? {};
    if (item.data?.separator) {
      return <div className="vertical-divider" />;
    }

    // todo: check tooltips behavior

    const buttonProps = {
      className: customData.btnClass || "",
      mode: ButtonMode.Transparent,
      iconType: customData.icon,
      label: item.text,
      disabled: item.disabled,
      showMenu: !!item.items,
      onClick: customData?.onClick,
      title: customData.tooltip,
      badge: customData.badge && customData.badge > 0 ? customData.badge : undefined,
    };

    const onLinkClick = (evt) => {
      if (customData.singleInstanceId || customData.isExternal || customData.openInNewTab) {
        evt.stopPropagation();
        onNavigateAway?.();
      }
    };

    if (customData.isExternal && item.url) {
      return (
        <a
          className={`tc-appbar-menu-link ${customData.linkClass || ""}`}
          href={item.url}
          onClick={onLinkClick}
          rel="noreferrer"
          target="_blank"
        >
          <Button {...buttonProps} />
          <Icon className="tc-appbar-menu-icon" type={IconType.ExternalLink} />
        </a>
      );
    }

    if (item.disabled || !item.url) {
      return <Button {...buttonProps} />;
    }
    return (
      <TruLink
        className="tc-appbar-menu-link"
        encounterOpened={encounterOpened}
        hasChangesCallback={hasChangesCallback}
        isErrorMode={isErrorMode}
        openInNewTab={!!customData.openInNewTab}
        singleInstanceId={customData.singleInstanceId}
        to={item.url}
      >
        <Button {...buttonProps} />
        {encounterOpened && <Icon className="tc-appbar-menu-icon" type={IconType.ExternalLink} />}
      </TruLink>
    );
  };
}
